
window.styleFilter = {

	local : null,
	isopened : false,

	//
	wrap : null,
	btn : null,
	target : null,

	//
	click : {
		event : null,
		func : null
	},
	mouseenter : {
		event : null,
		func : null
	},
	mouseleave : {
		event : null,
		func : null
	},

	onInit( elem ){

		this.local  = !elem ? document.querySelector('.c-local') : elem;
		this.wrap   = this.local.querySelector('.js-sort');
		this.btn    = this.local.querySelector('.js-open-sort');
		this.target = this.local.querySelector('.js-open-sort-target');
		if( this.wrap ){
			this.addEvents();
		}

	},

	addEvents(){

		//
		this.click.func = (e) => {
			e.preventDefault();
			this.onToggle();
		}
		this.click.event = this.btn.addEventListener('click', this.click.func );

		//
		if( !DETECT.device.any ){
			this.mouseenter.func = () => {
				this.onOpen();
			}
			this.mouseleave.func = () => {
				this.onClose();
			}
			this.mouseenter.event = this.btn.addEventListener('mouseenter', this.mouseenter.func );
			this.mouseleave.event = this.wrap.addEventListener('mouseleave', this.mouseleave.func );
		}

	},

	onDestroy(){
		if( this.click.event ){
			this.btn.removeEventListener('click', this.click.func );
			this.click.event = null;
		}
		if( this.mouseenter.event ){
			this.btn.removeEventListener('mouseenter', this.mouseenter.func );
			this.mouseenter.event = null;
		}
		if( this.mouseleave.event ){
			this.wrap.removeEventListener('mouseleave', this.mouseleave.func );
			this.mouseleave.event = null;
		}
	},

	onToggle(){
		if( !this.isopened ){
			this.onOpen();
		} else {
			this.onClose();
		}
	},

	onOpen(){
		this.isopened = true;
		this.wrap.classList.add('is-o');
	},

	onClose(){
		this.isopened = false;
		this.wrap.classList.remove('is-o');
	},


}
